/* global G */
import { asyncpipe } from 'lib/util'

/**
 * Attempts to generate a new messaging token for the current device.
 *
 * @param {Gaia.Mobile.Application} obj  the Platform Application
 * @returns {Promise<*>}
 */
const registerDevice = async (obj) => {
  const httpAdapter = obj[G.ADAPTER][G.HTTP][G.API]

  const params = {
    platform: 'web',
  }
  // Save the token
  try {
    const options = { middleware: ({ loader, ...middleware }) => Object.values(middleware) }
    await httpAdapter.post({ url: '/api/v1/devicetoken', params }, options)
  } catch (e) {
    console.warn('Unable to register device for notifications', e)
  }
  return obj
}

export default obj => async () => await asyncpipe(
  registerDevice,
)(obj)
